import React from 'react'

const RadioImageGroupContext = React.createContext({})

export const RadioImageGroupContextProvider = RadioImageGroupContext.Provider

export default RadioImageGroupContext